export default __webpack_public_path__ + "static/media/Notfound.4a08883a.png";